import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import SortOption from "./sortOption";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const AllProduct = () => {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState("");


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/product`
        ); // Adjust the API endpoint as needed
        let filteredProducts = response.data;

        if (category && category !== 'allproduct') {
          filteredProducts = filteredProducts.filter(
            product => product.category === category
          );
        }

        let sortedProducts = filteredProducts;

        if (sort === "newest") {
          sortedProducts = filteredProducts.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
        } else {
          sortedProducts = filteredProducts.sort((a, b) => {
            const priceA = parseFloat(a.price.replace(/,/g, ""));
            const priceB = parseFloat(b.price.replace(/,/g, ""));
            if (sort === "LtoH") {
              return priceA - priceB;
            } else if (sort === "HtoL") {
              return priceB - priceA;
            }
            return 0; // To handle cases when sort is neither "LtoH" nor "HtoL"
          });
        }

        setProducts(sortedProducts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching the products:", error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, [sort, category]);

  const getSortValue = (sortValue) => {
    setSort(sortValue);
  };

  if (loading) {
    return (
      <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-1 md:gap-8 mb-4">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="bg-gray-100 overflow-hidden md:rounded-md">
            <Skeleton height={200} />
            <div className="p-4">
              <Skeleton height={20} width="80%" />
              <Skeleton height={20} width="60%" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="">
      <div className="text-white">.</div>
      <div className="mt-16">
        <div className="flex justify-between p-3 border mb-4 items-center">
          <p className="font-twentieth-century font-semibold md:text-xl text-gray-800">
            ALL PRODUCTS {category && category !== 'allproduct' && ` - ${category}`}
          </p>
          <SortOption getSortValue={getSortValue} />
        </div>

        <div className="container mx-auto grid grid-cols-2 md:grid-cols-4 gap-1 md:gap-8 mb-4">
          {products.map((product) => (
            <Link
              to={`/product/${product._id}`} // Assuming the product has an _id field
              key={product._id}
              className="bg-gray-100 overflow-hidden md:rounded-md transform transition duration-300 md:hover:scale-105 hover:shadow-lg"
            >
              {product.images && (
                <img
                  src={`${process.env.REACT_APP_URL}/${product.images[0]}`} // Replace '\\' with '/' in the path
                  alt={product.name}
                  className="w-full md:h-[480px] h-[280px] object-cover"
                />
              )}
              <div className="p-4">
                <h3 className="text-md font-twentieth-century font-medium text-gray-800 truncate">
                  {product.name}
                </h3>
                <h3 className="text-md font-twentieth-century font-medium text-gray-800">
                  ₹{product.price}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AllProduct;
